import Group from 'components/utils/Group'
import LuxPlusLabel from 'LuxKit/Label/LuxPlusLabel'
import PriceRowLuxPlusPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import PriceRowLuxPlusNonMemberPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusNonMemberPrice'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import { useFlightMemberPrice } from 'hooks/Flights/useFlightMemberPrice'

interface Props {
  flightDeal: Pick<App.FlightDeal, 'perAdultPrice' | 'luxPlusPerAdultPrice'>
}

function FlightDealPricing({ flightDeal }: Props) {
  const memberPrice = useFlightMemberPrice(flightDeal.perAdultPrice, flightDeal.luxPlusPerAdultPrice)
  if (memberPrice === undefined) {
    return <PriceRowPrice size="L" price={flightDeal.perAdultPrice} saleUnit="adult" />
  }
  return <Group direction="vertical" gap={4}>
    <LuxPlusLabel type="member-price-offer" saveAmount={flightDeal.perAdultPrice - memberPrice} hideSaveAmountPlus />
    <PriceRowLuxPlusPrice size="L" memberPrice={memberPrice} saleUnit="adult" logoPlacement="leading" />
    <PriceRowLuxPlusNonMemberPrice nonMemberPrice={flightDeal.perAdultPrice} />
  </Group>
}

export default FlightDealPricing
